import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from '../../components';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const ConfirmationModal = ({
  message,
  cancelText,
  confirmText,
  onConfirm,
  visible,
  toggle,
}) => {
  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  const renderingSubmitBtnText = confirmText || t('SUBMIT_BTN_DEFAULT');
  const renderingCancelBtnText = cancelText || t('CANCEL_BTN_DEFAULT');

  const handleToggle = (event) => {
    if (event) event.preventDefault();
    toggle();
  };

  const handleConfirm = (event) => {
    if (event) event.preventDefault();
    onConfirm();
  };

  return (
    <Modal visible={visible} className='confirmation-modal'>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <div className='modal__container__footer__left'>
          <a
            href='#/'
            onClick={handleToggle}
            className='btn btn-tertiary'
            id='closeModal'
          >
            {renderingCancelBtnText}
          </a>
          <a href='#/' onClick={handleConfirm} className='btn btn-primary'>
            {renderingSubmitBtnText}
          </a>
        </div>
      </ModalFooter>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  message: PropTypes.string.isRequired,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ConfirmationModal;
